import React, { useState, useEffect } from "react";
import { useUserContext } from "src/contexts/userContext";
import * as API from "src/api/request";
import moment from "moment";
import _ from "lodash";
import ResponsiveDataTable from "src/components/ResponsiveDataTable";
import { Column } from "primereact/column";

const Tool = () => {
  const { user } = useUserContext();
  const [list, setList] = useState([]);

  useEffect(() => {
    if (user.tn !== 0) {
      API.getEmployeeNorm(user.tn)
        .then((res) => {
          setList(_.orderBy(res, ["itemtypeid", "itemname"]));
        })
        .catch(() => setList([]));
    }
  }, [user.tn]);

  return (
    <>
      <ResponsiveDataTable
        scrollable
        dataKey="id"
        size="small"
        stripedRows
        showGridlines
        className="text-xs w-full"
        // multiSortMeta={multiSortMeta}
        scrollHeight={window.innerHeight - 255}
        responsiveLayout="scroll"
        value={list}
        header={<div className="p-2">Хамгаалах хэрэгслийн нормын мэдээлэл</div>}
        emptyMessage={
          <div className="text-xs text-orange-500 italic font-semibold">
            Мэдээлэл олдсонгүй...
          </div>
        }
        rowGroupMode="subheader"
        groupRowsBy="itemtypeid"
        rowGroupHeaderTemplate={(data) => {
          return (
            <React.Fragment>
              <span className="text-xs font-semibold">{data.itemtypename}</span>
            </React.Fragment>
          );
        }}
      >
        <Column
          align="center"
          header="№"
          field="ordern"
          className="text-xs"
          headerClassName="flex items-center justify-center"
          bodyClassName="flex items-center justify-center"
          style={{ minWidth: "30px", maxWidth: "30px" }}
          body={(data, options) => options.rowIndex + 1}
        />
        <Column
          align="center"
          header="Төлөв"
          className="text-xs"
          headerClassName="flex items-center justify-center"
          style={{ minWidth: "150px", maxWidth: "150px" }}
          body={(data) => {
            var name = "";
            var status = "";

            if (!data.end_date) {
              status = "Хугацаа болсон";
              name = " badge-danger";
            } else {
              if (data.time === 0) {
                status = "Элэгдлээр";
                name = " badge-success";
              } else {
                if (
                  moment() >= moment(data.end_date, "YYYY.MM.DD") ||
                  !data.end_date
                ) {
                  status = "Хугацаа болсон";
                  name = " badge-danger";
                } else {
                  status = " Хугацаа болоогүй";
                  name = " badge-secondary";
                }
              }
            }

            return <span className={"badge " + name}>{status}</span>;
          }}
        />
        <Column
          align="center"
          header="Давтамж /сараар/"
          field="time"
          className="text-xs"
          headerClassName="flex items-center justify-center"
          style={{ minWidth: "130px", maxWidth: "130px" }}
        />
        <Column
          align="center"
          header="Авах огноо"
          field="begin_date"
          className="text-xs"
          headerClassName="flex items-center justify-center"
          style={{ minWidth: "130px", maxWidth: "130px" }}
        />
        <Column
          align="center"
          header="Авсан огноо"
          field="fact_date"
          className="text-xs font-bold items-center justify-center"
          style={{ minWidth: "130px", maxWidth: "130px", fontWeight: "600" }}
        />
        <Column
          align="center"
          header="Дуусах огноо"
          field="end_date"
          className="text-xs"
          headerClassName="flex items-center justify-center"
          style={{ minWidth: "130px", maxWidth: "130px" }}
        />
        <Column
          header="Хамгаалах хэрэгслийн нэр"
          field="itemname"
          className="text-xs"
          headerClassName="flex items-center justify-center"
          // style={{ minWidth: "150px", maxWidth: "150px" }}
        />

        <Column
          header="Нэгж"
          field="unitname"
          className="text-xs"
          headerClassName="flex items-center justify-center"
          bodyClassName="flex items-center justify-center"
          style={{ minWidth: "70px", maxWidth: "70px" }}
        />
      </ResponsiveDataTable>
    </>
  );
};

export default Tool;
